export default __webpack_public_path__ + "static/media/lb-pt.548cd168.webp";